export default __webpack_public_path__ + "static/media/toggle_show_appreciation.c0838171.svg";